import { RAYON_PAR_DEFAUT, type RayonMinutes, rayonSchema } from '@carte/contrats/proches';
import { z } from 'zod';

function enBooleen(valeur: unknown): unknown {
  if (typeof valeur === 'string') return valeur === 'true' || valeur === '1';
  return valeur;
}

/**
 * Paramètres d'URL de `/proches` (SPEC 4, règle 2). Le départ d'une ville ou d'un lieu favori y
 * figure (`lon`, `lat`, `depart`) ; la position GPS reste en mémoire et n'est jamais mise dans l'URL.
 * Toute valeur invalide retombe sur la valeur par défaut : une URL copiée à la main ne casse pas l'écran.
 */
export const prochesUrlSchema = z.object({
  minutes: rayonSchema.catch(RAYON_PAR_DEFAUT).default(RAYON_PAR_DEFAUT),
  actifs: z.preprocess(enBooleen, z.boolean()).catch(true).default(true),
  controle: z.preprocess(enBooleen, z.boolean()).catch(false).default(false),
  lon: z.coerce.number().min(-180).max(180).optional().catch(undefined),
  lat: z.coerce.number().min(-90).max(90).optional().catch(undefined),
  depart: z.string().max(120).optional().catch(undefined),
  lieu: z.coerce.number().int().positive().optional().catch(undefined),
});

export type ProchesUrl = z.infer<typeof prochesUrlSchema>;
export type { RayonMinutes };
